'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002459 from "./presto.-Two-Factor-Auth-View$$anon$59.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002461 from "./presto.-Two-Factor-Auth-View$$anon$61.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002463 from "./presto.-Two-Factor-Auth-View$$anon$63.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002465 from "./presto.-Two-Factor-Auth-View$$anon$65.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$58() {
  this.bEA = null;
  this.bEs = null;
  this.bEt = false;
  this.bEB = null;
  this.bEC = false;
  this.bEF = null;
  this.bEy = null;
  this.bEz = false;
  this.bEu = null;
  this.bEv = false;
  this.bEw = null;
  this.bEx = false;
  this.bED = false;
  this.bEE = false;
  this.bEA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bEF = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$58 as $c_Lpresto_TwoFactorAuthView$$anon$58 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$58;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$58() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$58 as $h_Lpresto_TwoFactorAuthView$$anon$58 };
$h_Lpresto_TwoFactorAuthView$$anon$58.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bEA;
});
$p.M = (function() {
  if ((!this.bEt)) {
    this.bEs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bEt = true;
  }
  return this.bEs;
});
$p.O = (function() {
  if ((!this.bEC)) {
    this.bEB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bEC = true;
  }
  return this.bEB;
});
$p.E = (function() {
  return this.bEF;
});
$p.t = (function() {
  if ((!this.bEz)) {
    this.bEy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bEz = true;
  }
  return this.bEy;
});
$p.N = (function() {
  if ((!this.bEv)) {
    this.bEu = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002459.$c_Lpresto_TwoFactorAuthView$$anon$59(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002461.$c_Lpresto_TwoFactorAuthView$$anon$61())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002463.$c_Lpresto_TwoFactorAuthView$$anon$63())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bEv = true;
  }
  return this.bEu;
});
$p.Q = (function() {
  if ((!this.bEx)) {
    this.bEw = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002465.$c_Lpresto_TwoFactorAuthView$$anon$65();
    this.bEx = true;
  }
  return this.bEw;
});
$p.v = (function() {
  if ((!this.bEE)) {
    this.bED = false;
    this.bEE = true;
  }
  return this.bED;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee681) => ((p) => \u03b4scrutinee681.z8(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$58, "presto.TwoFactorAuthView$$anon$58", ({
  Ti: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$58 as $d_Lpresto_TwoFactorAuthView$$anon$58 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$58.js.map
